export default {
  methods: {
    /**
    * 西暦を和暦に変換させる。
    * @param date : 日付 'yyyy-mm-dd'
    */
    toWareki: function (data) {
      // 年月日に切り出して日付データを作成する。
      let year = data.substr(0, 4)
      let month = data.substr(5, 2)
      let date = data.substr(8, 2)
      const dt = new Date(year, (month - 1), date)

      // 和暦に変換させる（yy/mm/dd）
      let wYear = Number(year) - 1988
      wYear = wYear + ''
      if (Number(wYear) < 10) {
        wYear = '0' + wYear
      }
      let wareki = wYear + '/' + month + '/' + date

      let gengo = '平成'

      // 2019年5月～2021年4月は平成扱いにする。
      if (year === '2019' && Number(month) >= 5) {
        wareki = wareki.slice(2)
        wareki = '31' + wareki
        gengo = '平成'
      } else if (year === '2020') {
        wareki = wareki.slice(2)
        wareki = '32' + wareki
        gengo = '平成'
      } else if (year === '2021' && Number(month) <= 4) {
        wareki = wareki.slice(2)
        wareki = '33' + wareki
        gengo = '平成'
      }

      // 令和3年5月から令和扱いにする。
      const reiwa = new Date(2021, (5 - 1), 1)
      const reiwaflg = dt >= reiwa
      if (reiwaflg) {
        const num = wareki.indexOf('/')
        let warekiyear = wareki.substr(0, num) - 30
        // 一桁だった場合、0埋めの処理をする。
        if (String(warekiyear).length === 1) {
          warekiyear = ('0' + warekiyear).slice(-2)
        }
        wareki = warekiyear + wareki.slice(num)
        gengo = '令和'
      }
      // 元号に紐づく値を取得する。
      let gengonumber = ''
      if (gengo === '明治') {
        gengonumber = 0
      } else if (gengo === '大正') {
        gengonumber = 1
      } else if (gengo === '昭和') {
        gengonumber = 2
      } else if (gengo === '平成') {
        gengonumber = 3
      } else if (gengo === '令和') {
        gengonumber = 4
      }
      // データを返却するようにまとめる。
      const warekidata = {}
      year = wareki.substr(0, 2)
      month = wareki.substr(3, 2)
      date = wareki.substr(6, 2)
      warekidata.year = Number(year) // 和暦年 数値型
      warekidata.yearStr = year // 和暦年 文字列
      warekidata.month = Number(month) // 月 数値型
      warekidata.monthStr = month // 月 文字列型
      warekidata.date = Number(date) // 日 数値型
      warekidata.dayStr = date // 日 文字列型
      warekidata.gengo = gengo // 元号
      warekidata.gengonumber = Number(gengonumber) // 元号インデックス(WarekiInputで使用)
      warekidata.wareki = wareki
      return warekidata
    },
    /**
    * 西暦を和暦に変換させる。
    * @param date : 日付 'yyyy-mm-dd'
    */
    toWarekiFromH: function (data) {
      // 年月日に切り出して日付データを作成する。
      let year = data.substr(0, 4)
      let month = data.substr(5, 2)
      let date = data.substr(8, 2)
      const dt = new Date(year, (month - 1), date)

      // 和暦に変換させる（yy/mm/dd）
      let wYear = Number(year) - 1988
      wYear = wYear + ''
      if (Number(wYear) < 10) {
        wYear = '0' + wYear
      }
      let wareki = wYear + '/' + month + '/' + date

      let gengo = '平成'

      // 2019年5月～2021年4月は平成扱いにする。
      if (year === '2019' && month >= '05') {
        wareki = wareki.slice(2)
        wareki = '31' + wareki
        gengo = '平成'
      } else if (year === '2020') {
        wareki = wareki.slice(2)
        wareki = '32' + wareki
        gengo = '平成'
      } else if (year === '2021' && month <= '04') {
        wareki = wareki.slice(2)
        wareki = '33' + wareki
        gengo = '平成'
      }
      // 令和3年5月から令和扱いにする。
      const reiwa = new Date(2021, (5 - 1), 1)
      const reiwaflg = dt >= reiwa
      if (reiwaflg) {
        const num = wareki.indexOf('/')
        let warekiyear = wareki.substr(0, num) - 30
        // 一桁だった場合、0埋めの処理をする。
        if (String(warekiyear).length === 1) {
          warekiyear = ('0' + warekiyear).slice(-2)
        }
        wareki = warekiyear + wareki.slice(num)
        gengo = '令和'
      }
      // 元号に紐づく値を取得する。
      let gengonumber = ''
      if (gengo === '平成') {
        gengonumber = 0
      } else if (gengo === '令和') {
        gengonumber = 1
      }
      // データを返却するようにまとめる。
      const warekidata = {}
      year = wareki.substr(0, 2)
      month = wareki.substr(3, 2)
      date = wareki.substr(6, 2)
      warekidata.year = Number(year) // 和暦年 数値型
      warekidata.yearStr = year // 和暦年 文字列
      warekidata.month = Number(month) // 月 数値型
      warekidata.monthStr = month // 月 文字列型
      warekidata.date = Number(date) // 日 数値型
      warekidata.dayStr = date // 日 文字列型
      warekidata.gengo = gengo // 元号
      warekidata.gengonumber = Number(gengonumber) // 元号インデックス(WarekiInputで使用)
      return warekidata
    },
    /**
    * 和暦を西暦に変換させる。
    * @param date : 年号+年 '平成02'
    */
    toSeireki: function (warekiStr) {
      // 年月日に切り出して日付データを作成する。
      const gengo = warekiStr.substr(0, 2)
      let year = warekiStr.substr(2)

      if (year === '元') {
        year = 1
      }

      // 元号に紐づく値を取得する。
      let yearCalcValue = null
      if (gengo === '明治') {
        yearCalcValue = 1867
      } else if (gengo === '大正') {
        yearCalcValue = 1911
      } else if (gengo === '昭和') {
        yearCalcValue = 1925
      } else if (gengo === '平成') {
        yearCalcValue = 1988
      } else if (gengo === '令和') {
        yearCalcValue = 2018
      }

      const seireki = Number(yearCalcValue) + Number(year)

      return seireki
    },
    /**
     * 年月文字列をDate型にParseします.
     * @param date : 日付 'yyyy-mm'
     */
    dateParseYearMonth (date) {
      const year = Number(date.substr(0, 4))
      const month = Number(date.substr(5, 2)) - 1
      return new Date(year, month)
    },
    /**
    * 現在の消費税を算出する。
    */
    taxRate: function () {
      // var now = new Date()
      // var fiveStart = new Date(1997, 4, 1)
      // var eightStart = new Date(2014, 4, 1)
      // // CMS/POSが9/30の23:55に切り替わるのでCMS/POSに合わせる
      // var tenStart = new Date(2019, 9, 30, 23, 55)
      // if (now.getTime() < fiveStart.getTime()) {
      //   return 0.03
      // } else if (now.getTime() >= fiveStart.getTime() && now.getTime() < eightStart.getTime()) {
      //   return 0.05
      // } else if (now.getTime() >= eightStart.getTime() && now.getTime() < tenStart.getTime()) {
      //   return 0.08
      // } else if (now.getTime() >= tenStart.getTime()) {
      //   return 0.1
      // }
      return 0.1
    },
    /**
     * 整数の場合trueを返します.
     * @param {*} x :判定オブジェクト
     */
    isInteger: function (value) {
      return String(value).match(/^([1-9]\d*|0)$/)
    },
    appHomeBack: function () {
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.homeBack()
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.homeBack.postMessage('')
      }
    },
    /**
     * イベントトラッキング：ページビュー(PVset)
     * @param {string} screenName スクリーン名
     */
    nativePVset: function (screenName) {
      // console.log('@@@@@@@ nativePVset start')
      // console.log(screenName)
      const json = JSON.stringify({ SHOWPAGE: screenName })
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.PVSet(json)
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.PVSet.postMessage(json)
      }
      // console.log(json)
      // console.log('@@@@@@@ nativePVset end')
    },
    /**
     * イベントトラッキング：イベント送信(EVENTSet)
     * @param {string} eventName イベント名（パラメータ名）
     * @param {string} buttonName ボタン名
     * @param {string} actionName アクション名（Value）
     */
    nativeEVENTSet: function (eventName, buttonName, actionName) {
      // console.log('@@@@@@@ nativeEVENTSet start')
      // console.log(eventName)
      // console.log(buttonName)
      // console.log(actionName)
      /** ネイティブへ渡す形式
      {
        "EVENTNAME": "PushSettinsButton",  //イベント名
        "PUSH_ON": "TAP"  //ボタン名：アクション名
      }
      */
      // キーに変数の値を使うため、ブラケット表記でjsonを設定
      const baseJson = { EVENTNAME: eventName }
      baseJson[buttonName] = actionName

      const json = JSON.stringify(baseJson)
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.EVENTSet(json)
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.EVENTSet.postMessage(json)
      }
      // console.log(json)
      // console.log('@@@@@@@ nativeEVENTSet end')
    },
    /**
     * 戻るボタン出し分けのfunction
     * @param {boolean}
     */
    appDisplayBack: function (bool) {
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.displayBack(bool)
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.displayBack.postMessage(bool)
      }
    }
  }
}
